import { render } from "./Camera.vue?vue&type=template&id=52ab497a"
import script from "./Camera.vue?vue&type=script&lang=js"
export * from "./Camera.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\forteapp-sales\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QBtn,QDialog,QCard,QImg,QCardSection,QCardActions});qInstall(script, 'directives', {ClosePopup});
